<template>
  <div class="nav-wrapper"> 
    <div class="experience-container">
      <div class="form-section">
        <h1 class="main-title">{{ $t('businessDetails.title') }} <span>{{ $t('businessDetails.fast') }}</span> {{ $t('businessDetails.with') }} <span>Tartoro.</span></h1>
        <p class="subtitle">{{ $t('businessDetails.subtitle') }}</p>

        <form @submit.prevent="handleNext" class="business-form-home">
          <div class="form-group">
            <label class="required">{{ $t('businessDetails.businessName.label') }}</label>
            <input type="text" v-model="businessName" :placeholder="$t('businessDetails.businessName.placeholder')"
              class="form-input" :class="{ 'error': errors.businessName }" />
            <span class="error-message" v-if="errors.businessName">{{ $t(errors.businessName) }}</span>
          </div>

          <div class="form-group">
            <label>{{ $t('businessDetails.alternativeName.label') }}</label>
            <input type="text" v-model="alternativeName" :placeholder="$t('businessDetails.alternativeName.placeholder')"
              class="form-input" />
          </div>

          <div class="form-group">
            <label class="required">{{ $t('businessDetails.formationState.label') }}</label>
            <select v-model="formationState" class="form-input custom-select" :class="{ 'error': errors.formationState }">
              <option value="" disabled selected>{{ $t('businessDetails.formationState.placeholder') }}</option>
              <option v-for="state in states" :key="state" :value="state">
                {{ state }}
              </option>
            </select>
            <span class="error-message" v-if="errors.formationState">{{ $t(errors.formationState) }}</span>
          </div>

          <button type="submit" class="next-button">{{ $t('businessDetails.next') }}</button>
        </form>
      </div>
      <div class="image-section">
        <img src="@/assets/slider1.png" alt="Productive workspace with laptop" class="main-image">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BusinessDetails',
  data() {
    return {
      businessName: '',
      alternativeName: '',
      formationState: '',
      states: ['Utah'],
      errors: {
        businessName: '',
        formationState: ''
      }
    }
  },
  methods: {
    validateForm() {
      let isValid = true;
      this.errors = {};

      if (!this.businessName.trim()) {
        this.errors.businessName = this.$t('businessDetails.businessName.errors.required');
        isValid = false;
      } else if (this.businessName.trim().length < 2) {
        this.errors.businessName = this.$t('businessDetails.businessName.errors.minLength');
        isValid = false;
      } else if (this.businessName.trim().length > 100) {
        this.errors.businessName = this.$t('businessDetails.businessName.errors.maxLength');
        isValid = false;
      } else if (!/^[a-zA-Z0-9\s\-&.,'()]+$/.test(this.businessName)) {
        this.errors.businessName = this.$t('businessDetails.businessName.errors.format');
        isValid = false;
      }

      if (!this.formationState) {
        this.errors.formationState = this.$t('businessDetails.formationState.errors.required');
        isValid = false;
      }

      return isValid;
    },
    handleNext() {
      if (this.validateForm()) {
        this.$emit('next', {
          businessName: this.businessName,
          alternativeName: this.alternativeName,
          formationState: this.formationState
        });
      }
    }
  }
}
</script>

<style scoped>
@import '@/styles/CustomerBusiness.css';
</style> 